import React, { useEffect, useState } from "react";
import { FPaquetesStyle } from "./styles";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
} from "@material-ui/core";
import TablaRegistro from "./TablaResgistro";
import useCatalogos from "../../../hooks/useCatalogos";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { obtenerHabitacionesByIdPaqueteAction } from "../../../ducks/habitacionDuck";
import { altaHabitacionPaqueteAction } from "../../../ducks/paqueteDuck";
import BackDrop from "./../../../global/BackDrop";
import HeaderModal from "../../../global/headerModal";
import InputAdornment from "@material-ui/core/InputAdornment";
import ModalBase from "../../../global/ModalBase";
const FPaquetesHabitaciones = (props) => {
  const { open = true, setOpen = () => {}, rowData = {} } = props;

  const dispatch = useDispatch();
  const habitacionesPaquetes = useSelector((state) => state.habitaciones.array);
  const classes = FPaquetesStyle();
  const catTipoPlaza = useCatalogos("TipoPlaza");
  const [idTipoPlaza, setIdTipoPlaza] = useState(0);
  const [suplemento, setSuplemento] = useState(0);
  const [disponibilidad, setDisponibilidad] = useState(0);
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    dispatch(obtenerHabitacionesByIdPaqueteAction(rowData.IdPaquete));
  }, [dispatch, rowData.IdPaquete]);
  
  const onGuardar = () => {
    if (!habitacionesPaquetes.find(habitacion => habitacion.TipoPlaza.IdTipoPlaza === idTipoPlaza)){
      let payload = {
        IdPaquete: rowData.IdPaquete,
        IdTipoPlaza: idTipoPlaza,
        Suplemento: suplemento,
        Disponibilidad: disponibilidad,
      };
      setIsLoad(true);
      dispatch(altaHabitacionPaqueteAction(payload)).then((Response) => {
        switch (Response.status) {
          case 500:
            ToastMessage.fire({
              icon: "error",
              title: "Ha habido un problema de conexión con el servidor",
            });
            break;
          case 400:
            ToastMessage.fire({
              icon: "warning",
              title: "<strong>Atención</strong>",
              text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
            });
            break;
          default:
            LimpiarForm();
            dispatch(
              obtenerHabitacionesByIdPaqueteAction(rowData.IdPaquete)
            ).then((Response) => {
              ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
              });
            });
            break;
        }
        setIsLoad(false);
      });
    } else {
      ToastMessage.fire({
        icon: "warning",
        title: "<strong>Atención</strong>",
        text: "Este tipo de plaza ya fue asignado.",
      });
    }
  };
  const LimpiarForm = () => {
    setIdTipoPlaza(0);
    setSuplemento(0);
    setDisponibilidad(0);
  };
  const handleClose = () => {
    setOpen(!open);
    LimpiarForm();
  };
  const handleSelect = (event) => {
    setIdTipoPlaza(event.target.value);
  };
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        titulo={`Habitaciones para el paquete ${rowData.Nombre}`}
        handleClose={handleClose}
      />
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={6}>
          <TablaRegistro
            rows={habitacionesPaquetes}
            idPaquete={rowData.IdPaquete}
          />
        </Grid>
        <Grid item xs={6}>
          <Grid container className={classes.containerSpacing}>
            <Grid item xs={12}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="SLTipoPlaza">Tipo plaza</InputLabel>
                <Select
                  labelId="SLTipoPlaza"
                  id="SLTipoPlaza"
                  name="tipoPlaza"
                  value={idTipoPlaza}
                  onChange={handleSelect}
                  label="Tipo plaza"
                >
                  <MenuItem value="0" disabled>
                    {"Seleccione una opción"}
                  </MenuItem>
                  {catTipoPlaza.map((item, index) => (
                    <MenuItem key={item.IdTipoPlaza} value={item.IdTipoPlaza}>
                      {`${item.Descripcion} - ${item.Personas} huésped`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                id="input-Suplemento"
                label="Suplemento"
                type="text"
                variant="outlined"
                name="suplemento"
                value={suplemento}
                onChange={(event) => {
                  setSuplemento(event.target.value);
                }}
                className={classes.textField}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {rowData.Moneda ? `${rowData.Moneda.Clave}` : ""}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                id="input-Cupo"
                label="Diponibilidad"
                type="text"
                variant="outlined"
                name="disponibilidad"
                value={disponibilidad}
                onChange={(event) => {
                  setDisponibilidad(event.target.value);
                }}
                className={classes.textField}
              />
            </Grid>
            <Grid item xs={12} className={classes.modalBotonesCenter}>
              <Button
                onClick={() => {
                  onGuardar();
                }}
                variant="contained"
                color="primary"
                className={classes.modalBoton}
                disabled={idTipoPlaza > 0 ? false : true}
              >
                Agregar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="Primary"
            className={classes.modalBoton}
          >
            Aplicar
          </Button>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </ModalBase>
  );
};
export default FPaquetesHabitaciones;
